var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 82,
    height: 82,
    rx: 41,
    stroke: "url(#gradient-911)",
    strokeWidth: 6,
    shapeRendering: "geometricPrecision",
    id: "rect5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 60.629485,47.673801 H 36.723679 v -5.021434 h 23.905806 z",
    stroke: "url(#gradient-911)",
    strokeWidth: 3.34004,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 22.270511,47.673801 h -5.193483 v -5.021434 h 5.193483 z",
    stroke: "url(#gradient-911)",
    strokeWidth: 3.34004,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 80.276056,47.673801 h -5.193475 v -5.021434 h 5.193475 z",
    stroke: "url(#gradient-911)",
    strokeWidth: 3.34004,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 69.221469,60.222624 H 60.62963 V 30.104633 h 8.591839 z",
    stroke: "url(#gradient-911)",
    strokeWidth: 3.34004,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 75.082943,54.574251 H 69.221181 V 35.752066 h 5.861762 z",
    stroke: "url(#gradient-911)",
    strokeWidth: 3.34004,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 28.132129,30.104633 h 8.591767 v 30.117991 h -8.591767 z",
    stroke: "url(#gradient-911)",
    strokeWidth: 3.34004,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 22.270004,35.752066 h 5.861835 v 18.822185 h -5.861835 z",
    stroke: "url(#gradient-911)",
    strokeWidth: 3.34004,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g2",
    transform: "matrix(0.75962262,0,0,0.77687281,12.614193,27.540104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    y1: 46,
    id: "gradient-911",
    x1: 4,
    y2: 46,
    x2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6054B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/fitness.c27b62b9e01beb1503ece94a69852b7e.svg";
export { ForwardRef as ReactComponent };